<template>
    <div>
        <div class="row my-4">
            <div class="col-12">
                <h1 class="text-3xl ps-2">
                    {{ $t('Kontooversikt') }}
                </h1>
            </div>
        </div>

        <div class="row" v-show="!loading">
            <Summary></Summary>
            <SaleListWrapper></SaleListWrapper>
            <Export></Export>
        </div>

        <div class="row" v-show="loading">
            <div class="text-center col-12 py-3">
                <span class="spinner-border" role="status"></span>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import Store from '../../state/accountStore';
import SaleListWrapper from './SaleListWrapper';
import Summary from './Summary';
import Export from './Export';

const loading = computed(() => Store.isLoading());

onMounted(() => {
    Store.init();
});
</script>
